import { useAppSelector } from "@src/store/hooks";
import { Theme } from "@src/store/settingsSlice";

const useSvgFillColor = () => {
	const theme = useAppSelector((state) => state.settings.theme);
	const fillColor = theme === Theme.Light ? "#212121" : "#fafafa";

	return fillColor;
};

export default useSvgFillColor;
